// extracted by mini-css-extract-plugin
export default {"tag":"Z9qcEZU","tag--default":"fLp_B7e","tag--disabled":"I1rJfcy","tag--lime":"I48gdWY","tag__button":"_8SWFyJ","tag__icon":"BRsYfbE"};